import React, { ReactNode, useState } from "react"
import clsx from "clsx"
import ClickAwayListener from "@material-ui/core/ClickAwayListener"
import Tooltip from "@material-ui/core/Tooltip"
import { Zoom } from "@material-ui/core"
import Container from "@ecom/ui/components/Container"
import close_icon from "../../images/icons/icon_closeV2.svg"

import {
  Steps,
  DEFAULT_STEPS,
  STEPS_PKW,
  STEPS_REFIN,
  STEPS_REFIN_ZADOLZHENNOSTEJ,
  STEPS_HALVA,
  STEPS_REDISIGN_BEZPROCENTOV,
  STEPS_PKW_REDISIGN,
  STEPS_STICKER_PAY,
  STEPS_SHUBA,
  STEPS_24_MESYACA_BEZ_PROCENTOV,
  STEPS_NEWYEAR,
  STEPS_SHAPKA,
  STEPS_KIBERPONEDELNIK,
  STEPS_GENDER_ACTION,
  STEPS_PRODUCTS_CATEGORIES,
  STEPS_PROMOPAGE,
  STEPS_NEDELI_UMNUX_RASSROCHEK,
  STEPS_NEDELI_UMNUX_RASSROCHEK_MEDIA,
  STEPS_LENTA,
  STEPS_REFIN_KREDITNOY_KARTY,
  STEPS_PKW_OZON,
  STEPS_PKW_AVIASALES,
  STEPS_ZOON,
  STEPS_PKW_BONUS_1500,
  STEPS_100_CASHBACK,
  STEPS_BTS_AUTO,
  STEPS_AUTO_PROMO,
  STEPS_VK_EDUCATION,
  STEPS_HIPPO,
  STEPS_BLACK_FRIDAY_HALVA,
  STEPS_BLACK_FRIDAY,
  STEPS_PROCENTY_VERNET_MAGAZIN,
  STEPS_NEWYEAR_MEDIA,
  STEPS_NEWYEAR_HALVA,
  STEPS_RASSROCHKA_S_HALVOI,
  STEPS_MEDIA,
  STEPS_HIPPO_PARKING,
  STEPS_BACKTOSCHOOL,
  STEPS_GETHALVA_BTS,
  STEPS_KESHBECK_20,
  STEPS_KESHBECK_30,
  STEPS_KESHBECK_2000,
  STEPS_DOBROE_COFFEE,
  BEST_BENEFITS,
  STEPS_BLACK_FRIDAY_HALVA_2025,
  STEPS_BLACK_FRIDAY_HALVA_MEDIA,
  STEPS_GENDER_ACTION_MEDIA,
  CB_PROMO,
  STEPS_MAY_TRUD_HALVA,
  STEPS_SCHOOL_ACTION,
  STEPS_SMART_WEEKS,
} from "./helpers"

import * as styles from "./howInstallmentWorks.module.scss"

type Props = {
  variant?:
    | "pkw"
    | "blackFriday2025"
    | "standard"
    | "refin"
    | "refinZadolzhennostej"
    | "refinKreditnoyKarty"
    | "halva"
    | "redisignBezProcentov"
    | "pkwRedesign"
    | "promopage"
    | "stickerPay"
    | "shuba"
    | "mesyacaBezProcentov"
    | "newYear"
    | "shapka"
    | "kiberponedelnik"
    | "productsCategories"
    | "genderAction"
    | "nedeliUmnuxRassrochek"
    | "nedeliUmnuxRassrochekMedia"
    | "lenta"
    | "pkwOzon"
    | "pkwAviasales"
    | "zoon"
    | "bonus1500"
    | "cashback100"
    | "btsAuto"
    | "autoPromo"
    | "vkEducation"
    | "hippo"
    | "hippoparking"
    | "blackFridayHalva"
    | "blackFriday"
    | "procentyVernetMagazin"
    | "newYearMedia"
    | "newYearHalva"
    | "rassrochkaSHalvoi"
    | "media"
    | "backtoschool"
    | "gethalvaBTS"
    | "cashbeck20"
    | "cashbeck30"
    | "cashbeck2000"
    | "dobroeCoffee"
    | "bestBenefits"
    | "blackFridayHalvaMedia"
    | "genderActionMedia"
    | "cbPromo"
    | "mayTrudHalva"
    | "schoolAction"
    | "smartWeeks"

  orderNum?: string
  headTitle?: ReactNode
  pkwOther?: boolean
}

export const HowInstallmentWorks = ({
  variant = "standard",
  orderNum,
  headTitle = "Как работает рассрочка*",
  pkwOther = false,
}: Props) => {
  const steps: Steps[] = (() => {
    switch (variant) {
      case "pkw": {
        return STEPS_PKW
      }
      case "productsCategories": {
        return STEPS_PRODUCTS_CATEGORIES
      }
      case "shuba": {
        return STEPS_SHUBA
      }
      case "zoon": {
        return STEPS_ZOON
      }
      case "mesyacaBezProcentov": {
        return STEPS_24_MESYACA_BEZ_PROCENTOV
      }
      case "shapka": {
        return STEPS_SHAPKA
      }
      case "refin": {
        return STEPS_REFIN
      }
      case "refinZadolzhennostej": {
        return STEPS_REFIN_ZADOLZHENNOSTEJ
      }
      case "refinKreditnoyKarty": {
        return STEPS_REFIN_KREDITNOY_KARTY
      }
      case "standard": {
        return DEFAULT_STEPS
      }
      case "redisignBezProcentov": {
        return STEPS_REDISIGN_BEZPROCENTOV
      }
      case "pkwRedesign": {
        return STEPS_PKW_REDISIGN
      }
      case "stickerPay": {
        return STEPS_STICKER_PAY
      }
      case "newYear": {
        return STEPS_NEWYEAR
      }
      case "kiberponedelnik": {
        return STEPS_KIBERPONEDELNIK
      }
      case "genderAction": {
        return STEPS_GENDER_ACTION
      }
      case "promopage": {
        return STEPS_PROMOPAGE
      }
      case "nedeliUmnuxRassrochek": {
        return STEPS_NEDELI_UMNUX_RASSROCHEK
      }
      case "nedeliUmnuxRassrochekMedia": {
        return STEPS_NEDELI_UMNUX_RASSROCHEK_MEDIA
      }
      case "lenta": {
        return STEPS_LENTA
      }
      case "pkwOzon": {
        return STEPS_PKW_OZON
      }
      case "pkwAviasales": {
        return STEPS_PKW_AVIASALES
      }
      case "halva": {
        return STEPS_HALVA
      }
      case "bonus1500": {
        return STEPS_PKW_BONUS_1500
      }
      case "cashback100": {
        return STEPS_100_CASHBACK
      }
      case "btsAuto": {
        return STEPS_BTS_AUTO
      }
      case "autoPromo": {
        return STEPS_AUTO_PROMO
      }
      case "backtoschool": {
        return STEPS_BACKTOSCHOOL
      }
      case "gethalvaBTS": {
        return STEPS_GETHALVA_BTS
      }
      case "vkEducation": {
        return STEPS_VK_EDUCATION
      }
      case "hippo": {
        return STEPS_HIPPO
      }
      case "hippoparking": {
        return STEPS_HIPPO_PARKING
      }
      case "blackFriday2025": {
        return STEPS_BLACK_FRIDAY_HALVA_2025
      }
      case "mayTrudHalva": {
        return STEPS_MAY_TRUD_HALVA
      }
      case "blackFridayHalva": {
        return STEPS_BLACK_FRIDAY_HALVA
      }
      case "procentyVernetMagazin": {
        return STEPS_PROCENTY_VERNET_MAGAZIN
      }
      case "blackFriday": {
        return STEPS_BLACK_FRIDAY
      }
      case "newYearMedia": {
        return STEPS_NEWYEAR_MEDIA
      }
      case "newYearHalva": {
        return STEPS_NEWYEAR_HALVA
      }
      case "rassrochkaSHalvoi": {
        return STEPS_RASSROCHKA_S_HALVOI
      }
      case "media": {
        return STEPS_MEDIA
      }
      case "cashbeck20": {
        return STEPS_KESHBECK_20
      }
      case "cashbeck30": {
        return STEPS_KESHBECK_30
      }
      case "cashbeck2000": {
        return STEPS_KESHBECK_2000
      }
      case "dobroeCoffee": {
        return STEPS_DOBROE_COFFEE
      }
      case "bestBenefits": {
        return BEST_BENEFITS
      }
      case "blackFridayHalvaMedia": {
        return STEPS_BLACK_FRIDAY_HALVA_MEDIA
      }
      case "genderActionMedia": {
        return STEPS_GENDER_ACTION_MEDIA
      }
      case "cbPromo": {
        return CB_PROMO
      }
      case "schoolAction": {
        return STEPS_SCHOOL_ACTION
      }
      case "smartWeeks": {
        return STEPS_SMART_WEEKS
      }
      default: {
        return DEFAULT_STEPS
      }
    }
  })()

  const [openTooltip, setOpenTooltip] = useState(false)

  const handleTooltipClose = () => {
    setOpenTooltip(false)
  }

  const handleTooltipOpen = () => {
    setOpenTooltip(true)
  }

  return (
    <section className={clsx(styles.section, styles[variant])} data-exclude={orderNum}>
      <Container className={styles.container}>
        <h2 className={clsx(styles.title, styles[variant])}>{headTitle}</h2>
        <div className={styles.wrapper}>
          <ul className={clsx(styles.steps, styles[variant])}>
            {steps.map(({ title, subtitle, clickToolTip, textTooltip }, i) => (
              <li
                key={i}
                className={clsx(styles.step, styles[variant], { [styles.pkwOther]: pkwOther })}
              >
                <div
                  className={clsx(styles.stepText, styles[variant], {
                    [styles.pointer]: clickToolTip,
                  })}
                >
                  {clickToolTip ? (
                    <p className={clsx(styles.stepTitle, styles[variant])}>
                      <ClickAwayListener onClickAway={handleTooltipClose}>
                        <div>
                          <Tooltip
                            classes={{
                              tooltip: styles.tooltip,
                            }}
                            PopperProps={{
                              disablePortal: false,
                            }}
                            onClose={handleTooltipOpen}
                            open={openTooltip}
                            disableFocusListener
                            disableHoverListener
                            disableTouchListener
                            title={
                              <>
                                <div className={styles.hintModal}>{textTooltip}</div>
                                <div
                                  className={styles.close}
                                  onClick={handleTooltipClose}
                                  aria-hidden="true"
                                >
                                  <img src={close_icon} alt="close" />
                                </div>
                              </>
                            }
                            TransitionComponent={Zoom}
                          >
                            <div
                              className={styles.hintContainer}
                              onClick={handleTooltipOpen}
                              aria-hidden="true"
                            >
                              {title}
                            </div>
                          </Tooltip>
                        </div>
                      </ClickAwayListener>
                    </p>
                  ) : (
                    <p className={clsx(styles.stepTitle, styles[variant])}>{title}</p>
                  )}
                  <p
                    className={clsx(styles.stepSubtitle, styles[variant], {
                      [styles.pkwOther]: pkwOther,
                    })}
                  >
                    {subtitle}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </Container>
    </section>
  )
}
